import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

/**
 * 公开路由表
 */
export const publicRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login/index')
    },
    // 平台自动登录（收到 prepayMessage 后携带固定验证码登录）
    {
        path: '/auto_login',
        component: () => import('@/views/login/auto-login'),
        meta: {
            title: '加载中'
        }
    },
    // 首页
    {
        path: '/workbench',
        name: 'workbench',
        component: () => import('@/views/workbench/index.vue'),
        meta: {
            title: '工作台',
            icon: 'icon-menu-index'
        }
    },
    {
        path: '/index',
        redirect: '/userInfo',
        component: () => import('@/layout/index.vue'),
        children: [
            {
                path: '/userInfo',
                name: 'index',
                component: () => import('@/views/home/index.vue'),
                meta: {
                    title: '个人信息',
                    icon: 'icon-menu-index'
                }
            },
            {
                path: '/thermostat-history-data',
                name: 'thermostat-history-data',
                component: () => import('@/views/thermostat/history-data/index.vue'),
                meta: {
                    title: '历史采集数据',
                    icon: 'icon-menu-index'
                }
            },
            {
                path: '/open-app',
                name: 'open-app',
                component: () => import('@/views/factory/open-app/index.vue'),
                meta: {
                    title: '第三方平台密钥',
                    icon: 'icon-menu-index'
                }
            }
        ]
    },
    // 404
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/error-page/404.vue')
    },
    // 401
    {
        path: '/401',
        name: '401',
        component: () => import('@/views/error-page/401.vue')
    },
    {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('@/views/error-page/404.vue')
    }
]

/**
 * 初始化路由表
 */
export function resetRouter() {
    const allModules = store.getters.userInfo?.auths?.menus
    if (allModules) {
        for (const key in allModules) {
            const menuList = allModules[key]
            if (menuList.length) {
                menuList.forEach((ele) => {
                    ele.children &&
                        ele.children.forEach((item) => {
                            router.hasRoute(item.name) && router.removeRoute(item.name)
                        })
                })
            }
        }
    }
}

const router = createRouter({
    history: createWebHistory(),
    routes: publicRoutes
})

export default router
